export enum OrderState {
  Undefined = -1,
  Created = 0, // Weiß oder Grau
  Proofed = 1, // Hellgrün
  Released = 2, // Grün
  InProcess = 3, // Gelb
  Canceled = 4, // Rot
  PreProcessed = 5, // Hellblau
  Processed = 6, // Blau
  Finished = 7, // Lila
  Paused = 8, //Gelb-Grün
  CheckedOut = 9 //Schwarz
}
